import { useContext } from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Authentication from './components/authentication/Authentication';
import DashboardContext from './Context';
import LoginPage from './pages/loginpage/LoginPage';
import HomePage from './pages/index';
import Coustoumer from './pages/userprofiles/Custoumer';
import UnAuthentication from './components/authentication/UnAuthentication';
import WorkerId from './pages/forces/worker/WorkerId';
import NotFound from './pages/NotFound';
import Redirection from 'pages/Useraccess/Redirection';
import KarlineCustomerProfile from 'pages/userprofiles/KarlineCustomerProfile';

function App() {
  const { sideBardata } = useContext(DashboardContext);
  return (
    <CookiesProvider>
      <Router>
        <Switch>
          <Route
            path='/Customer/:id'
            render={(props) => {
              return <Coustoumer {...props} />;
            }}
          />
          <Route
            path='/KarlineCustomerProfile/:id'
            render={(props) => {
              return <KarlineCustomerProfile {...props} />;
            }}
          />
          <Route
            path='/Worker/:id'
            render={(props) => {
              return <WorkerId {...props} />;
            }}
          />
          <Route
            path='/Redirection/:phoneNumber'
            render={(props) => {
              return <Redirection {...props} />;
            }}
          />
          {sideBardata
            ? sideBardata.map((item) =>
              item.controllers.map((data) => {
                return (
                  <Authentication
                    key={data.controller}
                    path={`/${data.controller}`}
                    component={data.controller}
                  />
                );
              })
            )
            : null}

          <UnAuthentication path='/login' component={LoginPage} />
          <Route component={HomePage} exact path='/' />
          <Route path='*'>
            <NotFound />
          </Route>
        </Switch>
      </Router>
      <ToastContainer rtl />
    </CookiesProvider>
  );
}
export default App;
